import { VacanciesRepository } from '../repositories/vacancies.repository'

// repositories
const vacanciesRepository = new VacanciesRepository()

// types
import {
    VacanciesGetListResponseT,
    VacanciesGetFeedBacksListResponseT,
    VacanciesGetCategoriesListResponseT,
    VacanciesGetRegionsListResponseT,
    VacanciesGetExperienceListResponseT,
    VacanciesCreateExperiencePayloadT,
    VacanciesCreateExperienceResponseT,
    VacanciesCreateRegionPayloadT,
    VacanciesCreateRegionResponseT,
    VacanciesUpdateExperienceResponseT,
    VacanciesCreateCategoryPayloadT,
    VacanciesCreateCategoryResponseT,
    VacanciesUpdateRegionResponseT,
    VacanciesUpdateCategoryResponseT,
    VacanciesCreateVacancyPayloadT,
    VacanciesUpdateVacancyResponseT,
    VacanciesCreateVacancyResponseT,
    VacanciesGetVacancyResponseT,
    VacanciesUpdateVacancyStatusResponseT,
    VacanciesGetVacancyStatusesResponseT,
} from '@/core/types/vacancies.types'

export class VacanciesService {
    async getList(page: number): Promise<VacanciesGetListResponseT> {
        const response = await vacanciesRepository.getList(page)
        return response.data
    }

    async getVacancyStatuses(): Promise<VacanciesGetVacancyStatusesResponseT> {
        const response = await vacanciesRepository.getVacancyStatuses()
        return response.data
    }

    async getVacancy(vacancy_id: number): Promise<VacanciesGetVacancyResponseT> {
        const response = await vacanciesRepository.getVacancy(vacancy_id)
        return response.data
    }

    async getFeedBacksList(page: number): Promise<VacanciesGetFeedBacksListResponseT> {
        const response = await vacanciesRepository.getFeedBacksList(page)
        return response.data
    }

    async getCategoriesList(page: number): Promise<VacanciesGetCategoriesListResponseT> {
        const response = await vacanciesRepository.getCategoriesList(page)
        return response.data
    }

    async getRegionsList(page: number): Promise<VacanciesGetRegionsListResponseT> {
        const response = await vacanciesRepository.getRegionsList(page)
        return response.data
    }

    async getExperienceList(page: number): Promise<VacanciesGetExperienceListResponseT> {
        const response = await vacanciesRepository.getExperienceList(page)
        return response.data
    }

    async createExperience(
        experience_payload: VacanciesCreateExperiencePayloadT
    ): Promise<VacanciesCreateExperienceResponseT> {
        const response = await vacanciesRepository.createExperience(experience_payload)
        return response.data
    }

    async createRegion(
        region_payload: VacanciesCreateRegionPayloadT
    ): Promise<VacanciesCreateRegionResponseT> {
        const response = await vacanciesRepository.createRegion(region_payload)
        return response.data
    }

    async createCategory(
        category_payload: VacanciesCreateCategoryPayloadT
    ): Promise<VacanciesCreateCategoryResponseT> {
        const response = await vacanciesRepository.createCategory(category_payload)
        return response.data
    }

    async createVacancy(
        vacancy_payload: VacanciesCreateVacancyPayloadT
    ): Promise<VacanciesCreateVacancyResponseT> {
        const response = await vacanciesRepository.createVacancy(vacancy_payload)
        return response.data
    }

    async publishVacancy(vacancy_id: number): Promise<void> {
        await vacanciesRepository.publishVacancy(vacancy_id)
    }

    async archiveVacancy(vacancy_id: number): Promise<void> {
        await vacanciesRepository.archiveVacancy(vacancy_id)
    }

    async updateExperience(
        experience_id: number,
        experience_payload: VacanciesCreateExperiencePayloadT
    ): Promise<VacanciesUpdateExperienceResponseT> {
        const response = await vacanciesRepository.updateExperience(
            experience_id,
            experience_payload
        )
        return response.data
    }

    async updateRegion(
        region_id: number,
        region_payload: VacanciesCreateRegionPayloadT
    ): Promise<VacanciesUpdateRegionResponseT> {
        const response = await vacanciesRepository.updateRegion(region_id, region_payload)

        return response.data
    }

    async updateCategory(
        category_id: number,
        category_payload: VacanciesCreateCategoryPayloadT
    ): Promise<VacanciesUpdateCategoryResponseT> {
        const response = await vacanciesRepository.updateCategory(category_id, category_payload)
        return response.data
    }

    async updateVacancy(
        vacancy_id: number,
        vacancy_payload: VacanciesCreateVacancyPayloadT
    ): Promise<VacanciesUpdateVacancyResponseT> {
        const response = await vacanciesRepository.updateVacancy(vacancy_id, vacancy_payload)
        return response.data
    }

    async updateVacancyStatus(
        vacancy_id: number,
        status_id: number
    ): Promise<VacanciesUpdateVacancyStatusResponseT> {
        const response = await vacanciesRepository.updateVacancyStatus(vacancy_id, status_id)
        return response.data
    }

    async archiveFeedback(feedback_id: number): Promise<void> {
        await vacanciesRepository.archiveFeedback(feedback_id)
    }

    async unarchiveFeedback(feedback_id: number): Promise<void> {
        await vacanciesRepository.unarchiveFeedback(feedback_id)
    }

    async setFeedbackStatus(feedback_id: number, status_id: number): Promise<void> {
        await vacanciesRepository.setFeedbackStatus(feedback_id, status_id)
    }

    async deleteExperience(experience_id: number): Promise<void> {
        await vacanciesRepository.deleteExperience(experience_id)
    }

    async deleteRegion(region_id: number): Promise<void> {
        await vacanciesRepository.deleteRegion(region_id)
    }

    async deleteCategory(category_id: number): Promise<void> {
        await vacanciesRepository.deleteCategory(category_id)
    }

    async deleteVacancy(vacancy_id: number): Promise<void> {
        await vacanciesRepository.deleteVacancy(vacancy_id)
    }
}
